import { ApiService } from "./api.service";
import { PrimeIcons } from "@primevue/core/api";
import { DOMAIN } from "./domain-constant";
import { AppIcons } from "../constants/app-icons";
// import UserGemsService from "./user.gems.service";
export default class ReceivablesItemsService extends ApiService {
  template = "defaultTemplate";
  DOMAIN = DOMAIN.RECEIVABLE_ITEMS;
  icon = "Box";
  Width = 500;
  singular = this.terminology.file.singular;
  plural = this.terminology.file.plural;
  vowel = this.terminology.file.vowel;

  gemItems = [
    {
      key: "loader",
      label: "Goods",
      icon: AppIcons.PLUS,
      services: DOMAIN.GOOD,
    },
    {
      key: "loader",
      label: "Inventory Items",
      icon: AppIcons.BRIEFCASE2,
      services: DOMAIN.ACCT_PAYMENT,
    },
    {
      key: "loader",
      label: "Services",
      icon: AppIcons.DOCUMENT_WITH_TEXT,
      services: DOMAIN.SERVICE,
    },
    {
      key: "loader",
      label: "Other Charges",
      icon: AppIcons.CALENDAR,
      services: DOMAIN.OTHER_CHARGE,
    },
    {
      key: "loader",
      label: "Discounts",
      icon: AppIcons.PLUS,
      services: DOMAIN.DISCOUNT,
    },
    {
      key: "loader",
      label: "Adjust Inventory",
      icon: AppIcons.BRIEFCASE2,
      services: 56,
    },
  ];
}
